export enum WorkspaceType {
  WebApplication = "WebApplication",
  MobileWeb = "MobileWeb",
  AndroidNative = "AndroidNative", // ✅ MVP: Full support
  IOSNative = "IOSNative", // ⚠️ Schema only (POST-MVP execution)
  Rest = "Rest",
  Desktop = "Desktop",
  Database = "Database",
  Other = "other",
}

export const WorkspaceTypeLabels: Record<WorkspaceType, string> = {
  [WorkspaceType.WebApplication]: "Web Application",
  [WorkspaceType.MobileWeb]: "Mobile Web",
  [WorkspaceType.AndroidNative]: "Android",
  [WorkspaceType.IOSNative]: "iOS",
  [WorkspaceType.Rest]: "Rest",
  [WorkspaceType.Desktop]: "Desktop",
  [WorkspaceType.Database]: "Database",
  [WorkspaceType.Other]: "Other",
};

export const workspaceTypeOptions = Object.values(WorkspaceType).map(
  (value) => ({
    id: value,
    name: WorkspaceTypeLabels[value],
  }),
);

export const visibleWorkspaceTypeOptions = [
  { id: WorkspaceType.WebApplication, name: "Web Application" },
  { id: WorkspaceType.MobileWeb, name: "Mobile Web" },
  { id: WorkspaceType.AndroidNative, name: "Android" },
  { id: WorkspaceType.IOSNative, name: "iOS" },
];
